import { ApiTask } from '../api-types/task.api';
import { Task } from '../app-types/task.app';

export const transformApiTaskToAppTask = (input: ApiTask): Task => {
	return {
		id: input.id,
		description: input.description,
		helpText: input.helpText,
		initial: input.initial,
		validForP2: input.validForP2,
		validForP3: input.validForP3,
	};
};

export const transformApiTasksToAppTasks = (input: ApiTask[]): Task[] => {
	return input.map(transformApiTaskToAppTask);
};

export const transformAppTaskToApiTask = (input: Task): ApiTask => {
	return {
		id: input.id,
		description: input.description,
		helpText: input.helpText,
		initial: input.initial,
		validForP2: input.validForP2,
		validForP3: input.validForP3,
	};
};

export const transformAppTasksToApiTasks = (input: Task[]): ApiTask[] => {
	return input.map(transformAppTaskToApiTask);
};
